import React, { useState } from 'react'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
//import Footer from '../UIElements/Footer'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import rosterLogo from '../../../images/roster_transparent.png'
import k_logo from '../../../images/K_logo_transparent.png'
import c_logo from '../../../images/ClubChampionships.png'
import ck_logo from '../../../images/clubsKnapper_transparent.png'

const RosterAndScheduleHomeNavigation = (props) => {
	console.log('inside RosterAndScheduleHomeNavigation: ' + props.leagueId)

	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{/* <h1
					className='home-navigation__title'
					style={{ textShadow: 'black 2px 2px 2px' }}
				>
					Roster and Schedule
				</h1> */}
				<div className='headerWidth'>
					<img src={rosterLogo} className='rosterLogo' />
					{/* <a
						href='https://knapperusa.com/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<img src={k_logo} className='k_roster_Logo' alt='Knapper USA' />
					</a> */}
					<img
						src={ck_logo}
						className='k_schedules_Logo'
						alt='Club Championships'
					/>
				</div>
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default RosterAndScheduleHomeNavigation
